// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"eZ-z","sponsoredTooltipWrapper":"fZ-z","sponsoredTooltip":"gZ-z","newCard":"hZ-z"};